module.exports = __webpack_public_path__ + "media/images/landing/we_believe_3-f101bbaa2cbea8bbad6cc4ad77a349b6.png";